import { render, staticRenderFns } from "./adminStamps.vue?vue&type=template&id=0b500c7e"
import script from "./adminStamps.vue?vue&type=script&lang=js"
export * from "./adminStamps.vue?vue&type=script&lang=js"
import style0 from "./adminStamps.vue?vue&type=style&index=0&id=0b500c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports